/**
 * Campanha Cassems — Nova Andradina/MS.
 * Preços promocionais fixos na lista. Combo especial: assento + pés ou plataforma.
 * Ajuste ISOs com VITE_CASSEMS_*_ISO no build.
 */

/** Fallback % só para itens sem preço fixo nesta tabela */
export const CASSEMS_DESCONTO_PERCENTUAL = 30;

export const CASSEMS_COMBO_PRECO_PAR = 4000;
export const CASSEMS_COMBO_ASSENTO_ID = 'assento-shiatsu-premium';
export const CASSEMS_COMBO_FOOT_ID = 'massageador-pes-shiatsu-pro';
export const CASSEMS_COMBO_PLATAFORMA_ID = 'plataforma-reflexologia';

/** Preços promocionais fixos (R$) — demais itens usam CASSEMS_DESCONTO_PERCENTUAL sobre a tabela */
export const CASSEMS_PRECO_PROMO_FIXO: Record<string, number> = {
  'cinta-fisiopower': 1200,
  'colete-shiatsu': 1308,
  'assento-shiatsu-premium': 2999,
  'massageador-pes-shiatsu-pro': 1790,
  'plataforma-reflexologia': 1790,
  'almofada-shiatsu-lumina': 1690,
};

export function precoUnitarioCampanhaCassems(id: string, precoAVista: number): number {
  const fixo = CASSEMS_PRECO_PROMO_FIXO[id];
  if (fixo != null) return fixo;
  return Math.round(precoAVista * (1 - CASSEMS_DESCONTO_PERCENTUAL / 100) * 100) / 100;
}

/** @deprecated usar precoUnitarioCampanhaCassems */
export function precoComDescontoCassems(precoCheio: number, pct: number = CASSEMS_DESCONTO_PERCENTUAL): number {
  return Math.round(precoCheio * (1 - pct / 100) * 100) / 100;
}

/** WhatsApp para dúvidas da campanha */
export const CASSEMS_WA_DUVIDAS_E164 = '5567998576870';
export const CASSEMS_WA_DUVIDAS_LABEL = 'Demétrio Jr. · (67) 99857-6870';

export const CASSEMS_LANDING = {
  slug: 'cassems',
  pageTitle: 'Campanha Lunins — Cassems Nova Andradina | Bem-estar e autocuidado',
  metaDescription:
    'Equipamentos Lunins com preços de campanha no Cassems Nova Andradina. Combo especial, NF-e e atendimento pelo WhatsApp — janela limitada.',

  inicioCampanhaIso: '2026-03-23T20:00:00-04:00',
  fimCampanhaIso: '2026-03-26T20:00:00-04:00',

  evento: {
    label: 'Janela desta ação de bem-estar',
    resumoHorario: 'Encerramento dos preços desta página: 25 de março, às 20h (horário de Mato Grosso do Sul).',
  },

  hero: {
    eyebrow: 'Ação de bem-estar · Hospital Cassems · Nova Andradina',
    headline: 'Preços de campanha Lunins — encomenda em poucos passos',
    tagline:
      'Valores já aplicados na lista. Carrinho → PDF → WhatsApp para confirmar pagamento e entrega.',
  },

  /** Texto acima da grade de produtos */
  catalogLead: 'Preços da ação na grade. No final: PDF do pedido e contato com a equipe.',

  comboCard: {
    title: 'Combo R$ 4.000 (par)',
    body:
      'Assento Shiatsu Premium + pés (Shiatsu Pro) ou + plataforma de reflexologia — o par por R$ 4.000 nesta ação. Adicione os dois itens ao carrinho; o ajuste do combo entra no total automaticamente.',
    badgeAutomatico: 'Desconto do combo no total — automático',
  },

  contextoRodape: {
    title: 'Sobre esta ação',
    corpo:
      'Seleção Lunins com condições especiais nesta ação de bem-estar ligada ao Hospital Cassems em Nova Andradina. O cronômetro no topo mostra até quando esses preços valem — é compra direta com a fabricante.',
    legal:
      'A Lunins (L.D.Z Arquitetura Bem Estar LTDA) é fornecedora privada. O benefício é comercial e não se confunde com verba pública, licitação ou compra governamental.',
  },

  confianca: {
    title: 'Por que confiar na Lunins',
    corpo:
      'NF-e em nome do comprador, garantia conforme fabricante e pós-venda com time no MS. Acompanhe novidades no Instagram.',
    instagramLabel: '@luninsbr no Instagram',
    instagramHref: 'https://www.instagram.com/luninsbr/',
  },

  garantiaENota: {
    title: 'Nota fiscal, garantia e pós-venda',
    itens: [
      'Emitimos NF-e com os dados que você informar no fechamento — documento válido para garantia e para sua organização.',
      'A garantia segue as regras de cada produto; nossa equipe orienta registro e suporte após a compra.',
      'Dúvidas antes de fechar? Fale com Demétrio Jr. no WhatsApp (67) 99857-6870 — canal indicado nesta ação.',
    ],
  },

  objecoes: {
    title: 'Dúvidas comuns',
    itens: [
      {
        pergunta: 'Por que esses preços?',
        resposta:
          'São condições comerciais desta ação pontual em Nova Andradina, com prazo no cronômetro — para levar equipamentos de referência Lunins para casa com valor fechado nesta página.',
      },
      {
        pergunta: 'Os equipamentos são os mesmos do catálogo Lunins?',
        resposta:
          'Sim. A lista segue a curadoria Lunins; aqui você vê só os itens e os valores desta campanha.',
      },
      {
        pergunta: 'Como funciona o pagamento e a entrega?',
        resposta:
          'Não há cobrança automática pelo site. Depois do PDF, você combina com a equipe: PIX ou outras formas, horários e entrega na sua região.',
      },
      {
        pergunta: 'Tem material de uso dos aparelhos?',
        resposta:
          'Sim. No atendimento ou pelo Instagram @luninsbr você encontra orientações e dicas de uso.',
      },
      {
        pergunta: 'E se eu mudar de ideia antes de pagar?',
        resposta:
          'Preencher o formulário não debita nada. O próximo passo é o contato humano da Lunins — você só fecha se fizer sentido para você.',
      },
    ],
  },

  ctaWhatsappPrefix:
    'Olá, Demétrio! Vim da página Lunins — Cassems. Tenho dúvida sobre os equipamentos ou os preços.',

  checkoutReforco:
    'Use dados fiéis à documentação para NF-e e garantia. Guarde o PDF; a equipe confirma valores e pagamento pelo WhatsApp, PIX, link ou outra forma alinhada. O setor agiliza o atendimento.',
} as const;

/** Produtos disponíveis no carrinho da campanha (ids do catálogo interno) */
export const CASSEMS_CATALOGO_IDS = [
  'massageador-manual',
  'massageador-relax-confort-sem-fio',
  'cinta-fisiopower',
  'colete-shiatsu',
  'almofada-shiatsu-roller',
  'plataforma-reflexologia',
  'massageador-pes-shiatsu-pro',
  'assento-shiatsu-premium',
  'massageador-pistola',
  'esteira-vibro-neck-shoulder',
] as const;
